import React from "react";
import { ExternalLink, Smartphone } from "lucide-react";

export default function ProductsSection() {
  return (
    <section
      id="products"
      className="bg-white"
      data-testid="products-section"
    >
      <div className="container-kw section">
        <div className="max-w-2xl">
          <div className="eyebrow">What We Build</div>
          <h2 className="mt-5 font-display font-bold text-4xl md:text-5xl tracking-tight text-[color:var(--kw-black)]">
            Our Products
          </h2>
          <p className="mt-5 text-base md:text-lg text-[color:var(--kw-muted)] leading-relaxed">
            Each product we operate is built around a single idea: make the
            experience genuinely valuable for the people using it.
          </p>
        </div>

        <div className="mt-16 grid grid-cols-1 md:grid-cols-2 gap-6 md:gap-8">
          {/* Jantaquid */}
          <article
            className="product-card"
            data-testid="product-card-jantaquid"
          >
            <div className="flex items-center justify-between">
              <div
                className="h-12 w-12 rounded-xl flex items-center justify-center"
                style={{ background: "var(--kw-yellow)" }}
              >
                <span className="font-display font-black text-xl">J</span>
              </div>
              <span className="text-xs font-semibold uppercase tracking-[0.18em] text-[color:var(--kw-muted)]">
                Mobile Game
              </span>
            </div>
            <h3 className="mt-8 font-display font-bold text-3xl md:text-4xl tracking-tight">
              Jantaquid
            </h3>
            <p className="mt-4 text-base md:text-lg text-[color:var(--kw-muted)] leading-relaxed">
              A mobile game from King's Wake built for simple, engaging play on
              Android devices.
            </p>

            <div className="mt-8 flex flex-wrap gap-3">
              <a
                href="https://play.google.com/store/apps/details?id=com.jantaquid.game"
                target="_blank"
                rel="noopener noreferrer"
                className="btn-pill btn-accent"
                data-testid="jantaquid-playstore-link"
                aria-label="Open Jantaquid on Google Play"
              >
                <Smartphone className="h-4 w-4" />
                Play Store
                <ExternalLink className="h-4 w-4" />
              </a>
            </div>

            <div className="mt-5 text-xs text-[color:var(--kw-muted)]">
              Available now on Google Play.
            </div>
          </article>

          {/* Harday */}
          <article
            className="product-card"
            data-testid="product-card-harday"
          >
            <div className="flex items-center justify-between">
              <div
                className="h-12 w-12 rounded-xl flex items-center justify-center bg-[color:var(--kw-black)] text-white"
              >
                <span className="font-display font-black text-xl">H</span>
              </div>
              <span className="text-xs font-semibold uppercase tracking-[0.18em] text-[color:var(--kw-muted)]">
                Puzzle Platform
              </span>
            </div>
            <h3 className="mt-8 font-display font-bold text-3xl md:text-4xl tracking-tight">
              <a
                href="https://harday.co.in/dashboard"
                target="_blank"
                rel="noreferrer"
                className="inline-flex items-center gap-2 hover:text-[color:var(--kw-muted)] transition-colors"
                data-testid="harday-title-link"
              >
                Harday
                <ExternalLink className="h-5 w-5 md:h-6 md:w-6" />
              </a>
            </h3>
            <p className="mt-4 text-base md:text-lg text-[color:var(--kw-muted)] leading-relaxed">
              A puzzle-based platform where users solve challenges and win in
              engaging and enjoyable ways, designed to make problem-solving both
              rewarding and fun.
            </p>

            <div className="mt-8 flex flex-wrap gap-3">
              <a
                href="https://harday.co.in/dashboard"
                target="_blank"
                rel="noreferrer"
                className="btn-pill btn-accent"
                data-testid="harday-visit-btn"
              >
                Visit Harday
                <ExternalLink className="h-4 w-4" />
              </a>
            </div>

            <div className="mt-5 text-xs text-[color:var(--kw-muted)]">
              Live now at harday.co.in
            </div>
          </article>
        </div>
      </div>
    </section>
  );
}
